import component from './FullscreenMdEditor.vue'
export default component
